import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Body1, Body2, Title2 } from '@ui/Typography/Typography'
import { createFileData } from '@ui/components/FileUpload/FileUpload'
import { FileUploadIcon } from '@ui/icons/FileUpload.icon'

import { FileData, FileExtension } from './types'

import styles from './FileUpload.module.scss'

interface FileUploadSelectProps {
  acceptType?: FileExtension[]
  maxFileSize: number
  disabled?: boolean

  onUpload(file: FileData): void

  buttonText?: string
}

export const FileUploadSelect: React.FC<FileUploadSelectProps> = (props) => {
  const { acceptType = [], maxFileSize, disabled, onUpload } = props

  const { t } = useTranslation()

  const hiddenFileInput = useRef<HTMLInputElement | null>(null)

  const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const [selectedFile] = event.target.files || []
    if (!selectedFile) return

    onUpload(createFileData(selectedFile))
    event.target.value = ''
  }

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
  }

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    const droppedFile = e.dataTransfer.files?.[0]
    if (droppedFile) {
      onUpload(createFileData(droppedFile))
    }
  }

  return (
    <>
      <div className={styles.fileUploadWrapper} onDragOver={handleDragOver} onDrop={handleDrop}>
        <div className={styles.fileUploadIconWrapper}>
          <FileUploadIcon size={24} color='text-inverse-black-neutral' />
        </div>
        <div className={styles.descriptionWrapper}>
          <Title2 medium>{t('Drag and Drop files')}</Title2>
          <Body1>
            <div className={styles.restrictions}>
              {t('Upload restrictions', {
                size: maxFileSize,
                types: acceptType.map((x) => x.toUpperCase()).join(', '),
              })}
            </div>
          </Body1>

          <Body2 className={styles.browseFiles} medium>
            {t('Browse files')}
          </Body2>
        </div>
        <input
          type='file'
          ref={hiddenFileInput}
          onChange={handleUpload}
          disabled={disabled}
          className={styles.hiddenFileInput}
        />
      </div>
    </>
  )
}
